import { Heading, IconChevronLeft, Stack, Text } from '@n26/nxd'
import { useTranslation } from 'react-i18next'
import styles from './StepHeader.module.css'

type StepHeaderProps = {
  title: string
  onBack: () => void
  backLabel?: string
}

export const StepHeader = ({
  title,
  onBack,
  backLabel,
}: StepHeaderProps) => {
  const { t } = useTranslation()
  const resolvedBackLabel = backLabel ?? t('common.goBack')
  return (
    <Stack direction='vertical' space='12' align='flex-start'>
      <Heading level={1} variant='standard'>
        {title}
      </Heading>
      <button type='button' onClick={onBack} className={styles.back}>
        <Stack direction='horizontal' space='4' align='center'>
          <IconChevronLeft />
          <Text variant='standard'>{resolvedBackLabel}</Text>
        </Stack>
      </button>
    </Stack>
  )
}
